{
  "NotificationEngine": {
    "Unauthorized": "Unauthorized access. Please login.",
    "InternalServerError": "Server error due to technical issues. Please try again.",
    "Day": "Day",
    "Time": "Time",
    "Schedule": "Schedule Notification",
    "DeliveryFrequency": "Delivery Frequency",
    "EventCategory": "Event Category",
    "Events": "Events",
    "Home": "Home",
    "Email": "Email",
    "EmailSchedule": "Schedule Notification",
    "Event": "Event Description",
    "ApplyCheckbox": "Apply this schedule to all the events in this event category.",
    "GlobalInfo":"Changes will be applied to all subscribed events across all event categories. Any existing notification preferences on them will be overridden.",
    "DisabledEventsInfo":"You cannot unsubscribe or modify this event.",
    "UserPreference": {
      "SaveFail": "Changes not saved due to some technical issues. Please try again.",
      "SaveSuccess": "Changes have been successfully applied."
    }
  }
}